module.exports = __webpack_public_path__ + "img/17877_L.8b5a9a2c.png";